import { useLocation } from "wouter";
import { CRTScreen } from "../components/CRTScreen.tsx";
import { DocumentBrowser } from "../components/DocumentBrowser.tsx";

export function BrowserPage() {
  const [, setLocation] = useLocation();

  return (
    <CRTScreen>
      <div style={{ height: "100%", overflow: "auto" }}>
        <DocumentBrowser
          onSelect={(docId) => setLocation(`/doc/${docId}`)}
        />
      </div>
    </CRTScreen>
  );
}
